module.exports = __webpack_public_path__ + "img/tabuleiro.cfb06567.png";